import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CountryLanguageService {
  readonly countryLanguage = require('@ladjs/country-language');
  readonly locales = require('i18n-locales') as Array<string>;
}
